import script from "./AppAdsConfig.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAdsConfig.vue?vue&type=script&setup=true&lang=ts"

import "./AppAdsConfig.vue?vue&type=style&index=0&id=635150bb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635150bb"]])

export default __exports__